import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Container = styled.div<{ fullScreen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ fullScreen }) =>
    fullScreen &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  `}
`;

const Spinner = styled.div<{ size?: 'small' | 'medium' | 'large' }>`
  border: ${({ size }) => {
    switch (size) {
      case 'small':
        return '3px';
      case 'large':
        return '5px';
      default:
        return '4px';
    }
  }} solid ${({ theme }) => theme.colors.border};
  border-top: ${({ size }) => {
    switch (size) {
      case 'small':
        return '3px';
      case 'large':
        return '5px';
      default:
        return '4px';
    }
  }} solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  width: ${({ size }) => {
    switch (size) {
      case 'small':
        return '24px';
      case 'large':
        return '64px';
      default:
        return '40px';
    }
  }};
  height: ${({ size }) => {
    switch (size) {
      case 'small':
        return '24px';
      case 'large':
        return '64px';
      default:
        return '40px';
    }
  }};
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  fullScreen = false,
  size = 'medium',
}) => {
  return (
    <Container fullScreen={fullScreen}>
      <Spinner size={size} />
    </Container>
  );
};
